'use client';

import { __awaiter, __generator } from '../../../_virtual/_tslib.js';
import { useState, useRef, useEffect } from 'react';
import { getUserProfile, getProfileLevel } from '../../../services/resumes/index.js';
import { EMaritalStatus, EGender } from '../../../UploadResumeModal/type.js';
import { ELanguage } from '../../../Utils/constants.js';
import ModelError from '../../../services/model/index.js';
import { detectEncryptAccessToken } from '../../../Utils/helpers.js';

var DEFAULT_INTERVAL_CHECK_IDENTIFY = 50;
var sendHogIdentify = function (postHog, user, baseMsUrl) { return __awaiter(void 0, void 0, void 0, function () {
    var userProfilePromise, userLevelPromise, promiseResponse, response_1, userProfile, userLevel, maritalStatus, ex_1;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (!user || !(user === null || user === void 0 ? void 0 : user.userId) || !(user === null || user === void 0 ? void 0 : user.accessToken)) {
                    return [2 /*return*/];
                }
                if (!postHog) {
                    return [2 /*return*/];
                }
                _c.label = 1;
            case 1:
                _c.trys.push([1, 3, , 4]);
                userProfilePromise = getUserProfile(detectEncryptAccessToken(user === null || user === void 0 ? void 0 : user.accessToken), baseMsUrl);
                userLevelPromise = getProfileLevel(detectEncryptAccessToken(user === null || user === void 0 ? void 0 : user.accessToken), ELanguage.VI, baseMsUrl);
                return [4 /*yield*/, Promise.allSettled([userProfilePromise, userLevelPromise])];
            case 2:
                promiseResponse = _c.sent();
                response_1 = [null, null];
                promiseResponse.forEach(function (result) {
                    if (result.status === 'rejected') {
                        response_1.push(null);
                        return;
                    }
                    // fulfilled and no Model
                    if (result.status === 'fulfilled' && ((result === null || result === void 0 ? void 0 : result.value) instanceof ModelError || !(result === null || result === void 0 ? void 0 : result.value))) {
                        response_1.push(null);
                        return;
                    }
                    response_1.push(result.value);
                });
                userProfile = response_1[0];
                userLevel = response_1[1];
                maritalStatus = 'Empty';
                if ((userProfile === null || userProfile === void 0 ? void 0 : userProfile.maritalStatusId) === EMaritalStatus.SINGLE) {
                    maritalStatus = 'Single';
                }
                else if ((userProfile === null || userProfile === void 0 ? void 0 : userProfile.maritalStatusId) === EMaritalStatus.MARRIED) {
                    maritalStatus = 'Married';
                }
                postHog === null || postHog === void 0 ? void 0 : postHog.identify(user === null || user === void 0 ? void 0 : user.userId.toString(), {
                    is_jobseeker: true,
                    user_id: user === null || user === void 0 ? void 0 : user.userId,
                    resume_id: user === null || user === void 0 ? void 0 : user.resumeId,
                    job_title: user === null || user === void 0 ? void 0 : user.jobTitle,
                    job_level: user === null || user === void 0 ? void 0 : user.jobLevelId,
                    years_experience: user === null || user === void 0 ? void 0 : user.yearExperience,
                    location_city: user === null || user === void 0 ? void 0 : user.locationList,
                    current_jobfunction_id: userProfile === null || userProfile === void 0 ? void 0 : userProfile.currentJobFunction,
                    current_industry_id: userProfile === null || userProfile === void 0 ? void 0 : userProfile.currentIndustries,
                    highest_degree_id: (_a = userProfile === null || userProfile === void 0 ? void 0 : userProfile.highestDegreeId) !== null && _a !== void 0 ? _a : '',
                    gender: (userProfile === null || userProfile === void 0 ? void 0 : userProfile.genderId) === EGender.MALE ? 'Male' : 'Female',
                    marrigal_status: maritalStatus,
                    expected_job_level_id: userProfile === null || userProfile === void 0 ? void 0 : userProfile.jobLevelId,
                    is_searchable: !!(userProfile === null || userProfile === void 0 ? void 0 : userProfile.isSearchable),
                    wowcv_template_id: userProfile === null || userProfile === void 0 ? void 0 : userProfile.wowcvTemplateId,
                    profile_strength: (_b = userLevel === null || userLevel === void 0 ? void 0 : userLevel.attributes) === null || _b === void 0 ? void 0 : _b.profileStrength,
                    search_setting_id: user === null || user === void 0 ? void 0 : user.searchSettingSortType
                });
                return [3 /*break*/, 4];
            case 3:
                ex_1 = _c.sent();
                console.error('PostHog Error: ', ex_1);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * This useIdentify function is used to identify a user in PostHog.
 * @param user TAuthUser
 */
var useIdentify = function (user, baseMsUrl, options) {
    var _a;
    // Config
    var intervalTime = (_a = options === null || options === void 0 ? void 0 : options.intervalTime) !== null && _a !== void 0 ? _a : DEFAULT_INTERVAL_CHECK_IDENTIFY;
    var _b = useState(false), isIdentified = _b[0], setIsIdentified = _b[1];
    var _c = useState(true), isEnable = _c[0], setIsEnable = _c[1];
    var _d = useState(false), isSentIdentify = _d[0], setIsSentIdentify = _d[1];
    var intervalIdRef = useRef(null);
    var clearAllInterval = function () {
        intervalIdRef.current && clearInterval(intervalIdRef.current);
        intervalIdRef.current = null;
    };
    var checkingIdentified = function () {
        var _a;
        if (!window.posthog || !window.posthog._isIdentified || typeof window.posthog._isIdentified !== 'function') {
            return;
        }
        var isIdentifiedValue = (_a = window === null || window === void 0 ? void 0 : window.posthog) === null || _a === void 0 ? void 0 : _a._isIdentified();
        // Response value is not a boolean
        if (typeof isIdentifiedValue !== 'boolean') {
            return;
        }
        // Already identified
        if (isIdentifiedValue) {
            setIsIdentified(true);
            // Disable interval
            setIsEnable(false);
            clearAllInterval();
            return;
        }
        // Send identify
        if (!isSentIdentify) {
            sendHogIdentify(window === null || window === void 0 ? void 0 : window.posthog, user, baseMsUrl);
            setIsSentIdentify(true);
        }
    };
    useEffect(function () {
        if (!isEnable) {
            clearAllInterval();
            return;
        }
        clearAllInterval();
        intervalIdRef.current = setInterval(checkingIdentified, intervalTime);
        return function () { return clearAllInterval(); };
    }, [isEnable, isSentIdentify, user]);
    return {
        isIdentified: isIdentified
    };
};

export { DEFAULT_INTERVAL_CHECK_IDENTIFY, useIdentify as default, sendHogIdentify };
//# sourceMappingURL=index.js.map
